import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/question.svg'


const _hoisted_1 = { class: "tooltip__container" }
const _hoisted_2 = {
  class: "tooltip",
  role: "tooltip"
}

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    text: null
  },
  setup(__props: any) {



const tooltipToggle = ref<HTMLInputElement>();

function toggle() {
    tooltipToggle.value?.focus();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _imports_0,
      class: "icon",
      alt: "Question icon",
      role: "button",
      onClick: toggle
    }),
    _createElementVNode("input", {
      type: "text",
      id: "tooltip",
      class: "tooltip__toggle",
      ref_key: "tooltipToggle",
      ref: tooltipToggle
    }, null, 512),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
  ]))
}
}

})